import { TourMediaDataViewModel } from '@api/index';
import { Images } from '@components/galleries/multiple-image/MultipleImageView';
import { FALLBACK_IMAGE_URL } from '@constants/constants';

const FALLBACK_GALLERY_SIZE = 5;

export const formatTourImages = (
  images?: TourMediaDataViewModel[],
  name?: string
): Images[] =>
  (images?.length ? images : Array(FALLBACK_GALLERY_SIZE).fill(undefined)).map(
    (image, index) => ({
      url: image?.url?.toLowerCase() || FALLBACK_IMAGE_URL,
      alt: `${name} ${index + 1}`,
    })
  );
